import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AuthService } from 'app/base-module/base-service/auth.service';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(
        private authService: AuthService,
        private router: Router,
        private snackBar: MatSnackBar
    ) { }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    
    const prefix = this.authService.utilitesService?.urlPrefix;
    const isApiUrl = !!prefix && request.url.includes(prefix);
    
    const token = this.authService.getToken();
    const hasToken = !!token && token !== 'null' && token !== 'undefined';

    if (hasToken && isApiUrl) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

        // --- PARTE 2: TRATAR O ERRO / LOGOUT (Lógica do BaseInterceptor) ---
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                
                if (error.status === 401 || error.status === 419) {
                    
                    if (this.router.url.includes('/auth-handler') || request.url.includes('/auth/login')) {
                         return throwError(() => error);
                    }

                    this.handleAuthError();
                    this.showError("Sessão expirada. Faça login novamente.");
                    
                    return EMPTY;
                }

                if (error.status === 403) {
                    this.showError(error.error.message || "Acesso negado.");
                    return EMPTY;
                }

                return throwError(() => error);
            })
        );
    }

    private handleAuthError() {
        this.authService.logout();
        this.router.navigate(["/auth/login"]);
    }

    private showError(message: string) {
        this.snackBar.open(message, "X", {
            duration: 4000
        });
    }
}